export { useNocSmAccommodationPageVisit } from './useNocSmAccommodationPageVisit';